import {
  GET_NOTIFICATION_LIST_SUCCESS,
  OPEN_ADVERTISEMENT_SUCCESS,
  CLOSE_ADVERTISEMENT,
  RESET_NOTIFICATION,
  NOTIFICATION_LOADING_END,
} from '../actionConstants/advertisementConstants';

const emptyActiveAdvertisementInfo = Object.freeze({
  body: null,
  popupUrl: null,
});

export const initialState = Object.freeze({
  isLoading: true,
  advertisementsList: [],
  isOpen: false,
  activeAdvertisementInfo: emptyActiveAdvertisementInfo,
});

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_NOTIFICATION_LIST_SUCCESS: {
      const { advertisementsList } = payload;
      return {
        ...state,
        advertisementsList,
      };
    }
    case OPEN_ADVERTISEMENT_SUCCESS: {
      const { body, popupUrl, callbackAction } = payload;
      return {
        ...state,
        isOpen: true,
        activeAdvertisementInfo: {
          body,
          popupUrl,
          callbackAction,
        },
      };
    }
    case CLOSE_ADVERTISEMENT: {
      return {
        ...state,
        isOpen: false,
        activeAdvertisementInfo: emptyActiveAdvertisementInfo,
      };
    }
    case NOTIFICATION_LOADING_END: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case RESET_NOTIFICATION: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};
